import { render } from "./MessageAttachment.vue?vue&type=template&id=83495d24&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"

import "./MessageAttachment.vue?vue&type=style&index=0&id=83495d24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83495d24"]])

export default __exports__